// New: UI_REVAMP
import { Box, Flex, Grid, Input, Text } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useBetTwo2DStore } from '../../../stores/useBetTwo2DStore';
import { useGlobalToast } from '../../../utils/ShowToast';
import SelectionButton from '../../button/SelectionButton';
import './bet2.css';
import HotNumberText from './HotNumberText';

export const BetTwo2DKeypad = ({ onManualInteract, isDisabled, activeBetType }) => {
	const globalShowToast = useGlobalToast();
	const [activeSlot, setActiveSlot] = useState(0);

	const { slots, updateSlot, hotNumbers, soldOutNumbers } = useBetTwo2DStore();

	const firstInputRef = useRef(null);
	const secondInputRef = useRef(null);

	// 判断是否为热门号码
	const isHotNumber = (num) => {
		const formatted = num.toString().padStart(2, '0');
		return hotNumbers.some((p) => p.split(',')[activeSlot] === formatted);
	};

	const isSoldOut = (num) => {
		const formatted = num.toString().padStart(2, '0');
		return soldOutNumbers.some((p) => p.split(',')[activeSlot] === formatted);
	};

	const handleNumberClick = (number) => {
		if (isSoldOut(number)) return;

		onManualInteract?.();
		updateSlot(activeSlot, number);

		if (slots[activeSlot] === number) {
			updateSlot(activeSlot, null);
			return;
		}

		if (activeSlot === 0) {
			setActiveSlot(1);
			// Auto focus is handled by useEffect if needed, or just set active slot
		}
	};

	const blockInput = {
		isReadOnly: true,
		inputMode: 'none',
		onKeyDown: (e) => e.preventDefault(),
		onPaste: (e) => e.preventDefault(),
	};

	useEffect(() => {
		if (slots.length === 0) {
			setActiveSlot(0);
		}
	}, [slots]);

	const isBetTypeEmpty = activeBetType === null;
	const isFirstActive = activeSlot === 0 && !isDisabled && !isBetTypeEmpty;
	const isSecondActive = activeSlot === 1 && !isDisabled && !isBetTypeEmpty;

	useEffect(() => {
		if (activeSlot === 0) {
			firstInputRef.current?.focus();
		} else if (activeSlot === 1) {
			secondInputRef.current?.focus();
		}
	}, [activeSlot]);

	return (
		<Flex w='100%' h='auto'>
			<Flex direction='column' px={2} pt={1} flex='1'>
				<Text fontWeight={500} fontSize='12px' color='#5E5D61'>
					Numbers
				</Text>

				<Flex gap={2}>
					<Input
						ref={firstInputRef}
						value={slots[0] ? slots[0].toString().padStart(2, '0') : ''}
						bgColor={isFirstActive ? '#C7BFFF' : '#DAD4FF'}
						onClick={() => {
							onManualInteract?.();
							setActiveSlot(0);
						}}
						border={isFirstActive ? '2px solid' : '1px solid'}
						borderColor={isFirstActive ? '#3099ff' : 'transparent'}
						boxShadow={isFirstActive ? '0px 0px 8px rgba(69,124,238,0.5)' : 'none'}
						focusBorderColor={isFirstActive ? '#3099ff' : 'transparent'}
						textAlign='center'
						fontWeight='700'
						fontSize='24px'
						isReadOnly={isDisabled || isBetTypeEmpty}
						pointerEvents={isDisabled || isBetTypeEmpty ? 'none' : 'auto'}
						_hover={{}}
						{...blockInput}
					/>
					<Input
						ref={secondInputRef}
						value={slots[1] ? slots[1].toString().padStart(2, '0') : ''}
						bgColor={isSecondActive ? '#C7BFFF' : '#DAD4FF'}
						onClick={() => {
							onManualInteract?.();
							setActiveSlot(1);
						}}
						border={isSecondActive ? '2px solid' : '1px solid'}
						borderColor={isSecondActive ? '#3099ff' : 'transparent'}
						boxShadow={isSecondActive ? '0px 0px 8px rgba(69,124,238,0.5)' : 'none'}
						focusBorderColor={isSecondActive ? '#3099ff' : 'transparent'}
						textAlign='center'
						fontWeight='700'
						fontSize='24px'
						cursor={isDisabled || isBetTypeEmpty ? 'not-allowed' : 'default'}
						isReadOnly={isDisabled || isBetTypeEmpty}
						_hover={{}}
						{...blockInput}
					/>
				</Flex>

				<Box
					className='numbers-container'
					flex='1'
					overflowY='auto'
					mt={2}
					pointerEvents={isDisabled ? 'none' : 'auto'}
				>
					<Grid
						templateColumns={{
							base: 'repeat(3, 1fr)',
							lg: 'repeat(5, 1fr)',
						}}
						gap={2}
					>
						{Array.from({ length: 31 }, (_, i) => i + 1).map((num) => {
							const isSelected = slots[activeSlot] === num;
							const soldOut = isSoldOut(num);
							const disabled = isDisabled;
							const isBetTypeEmpty = activeBetType === null;
							const isHot = isHotNumber(num) && !soldOut && !isBetTypeEmpty;

							let state = 'default';
							if (disabled) state = 'disabled';
							else if (soldOut && !isBetTypeEmpty) state = 'soldOut';
							else if (isSelected && !isBetTypeEmpty) state = 'selected';
							else if (isBetTypeEmpty) state = 'default';

							return (
								<SelectionButton
									key={num}
									variant='numberPick'
									status={state}
									isBetTypeEmpty={isBetTypeEmpty}
									onClick={() => {
										if (isBetTypeEmpty) {
											globalShowToast({
												title: 'Please select Straight or Ramble',
												status: 'warning',
												position: 'top',
											});
											return;
										}
										if (!disabled && !soldOut) {
											handleNumberClick(num);
										}
									}}
								>
									<HotNumberText
										isHot={isHot}
										isSelected={isSelected}
										num={num.toString().padStart(2, '0')}
									/>
								</SelectionButton>
							);
						})}
					</Grid>
				</Box>
			</Flex>
		</Flex>
	);
};
